export default __webpack_public_path__ + "static/media/Gallery.ab41d0b3.jpg";